import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import styles from './ClinicPatientConsult.module.scss';
import { Row, Col, Card } from 'react-bootstrap';
import Loader from '../components/Loader';
import PatientHeader from '../components/PatientHeader';
import EditConsult from '../components/EditConsult';
import { ConsultaProvider } from '../contexts/ConsultaContext';
import { alertModal } from '../utils/modalController';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';


const ClinicPatientConsult: React.FC = () => {
    const {id} = useParams<{ id: string }>();
    const {consultaId} = useParams<{ consultaId: string }>();

    const [user, setUser] = useState<User | null>(null);
    const [age, setAge] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            fetchAuth(`${apiUrl}/consultorio/patients/${id}`)
        ])
            .then(async ([patientRes]) => {
                if (!patientRes.ok) {
                    const error_json = await patientRes.json();
                    throw new Error(error_json.message || "Erro desconhecido");
                }

                const patientJson = await patientRes.json();

                if(!patientJson.user){
                    throw new Error("Usuário não encontrado");
                }

                const userRes = await fetchAuth(`${apiUrl}/consultorio/users/${patientJson.user.id}`);

                if (!userRes.ok) {
                    const error_json = await userRes.json();
                    throw new Error(error_json.message || "Erro desconhecido");
                }

                const userJson = await userRes.json();

                setUser(userJson);
                setAge(userJson?.birthday ? Math.floor((new Date().getTime() - new Date(userJson.birthday).getTime()) / (1000 * 60 * 60 * 24 * 365)) : null);
            })
            .catch((err) => {
                console.error('Erro ao buscar dados:', err);
                alertModal('Erro ao buscar dados: ' + err);
                setUser(null);
                setAge(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    if (loading) return <Loader />;

    return (
        <>
            <Container className={styles.container}>
                <h2 className={styles.title}>Consultório</h2>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <Row className={styles["row-card"]}>
                            <Col>
                                <PatientHeader
                                    user={user!}
                                    age={age}
                                    breadcrumbItems={[
                                        { label: "Consultório", href: "/consultorio" },
                                        { label: "Pacientes", href: "/consultorio/pacientes" },
                                        { label: user?.name || "Paciente", href: `/consultorio/pacientes/${id}` },
                                        { label: "Consultas", href: `/consultorio/pacientes/${id}/consultas` },
                                        { label: "Consulta" },
                                    ]}
                                />
                            </Col>
                        </Row>
                    </>
                )}
            </Container>
            <Container className="my-4">
                <Row className="data-content align-items-center">
                    <Col>
                        <Card className={styles["boas-vindas"]}>
                            <Card.Header className={styles["center"]}>
                                <Card.Title className={styles.h1}>Consulta</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <ConsultaProvider>
                                    <EditConsult pacienteId={id ?? '0'} consultaId={consultaId} />
                                </ConsultaProvider>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ClinicPatientConsult;
